var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.localePath(_vm.$routes.home.name),"rel":"home"}},[_c('img',_vm._b({class:_vm.classes,attrs:{"alt":"Ostado Inc.","src":_vm.src}},'img',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }